export const PAYMENT_DASHBOARD_PATH = '/payment/payment-dashboard';

export const trimQueryValue = (value?: string | null): string =>
  String(value || '').trim();

export const readIdFromSearch = (search: string): string => {
  const normalized = search.startsWith('?') ? search.slice(1) : search;
  return trimQueryValue(new URLSearchParams(normalized).get('id'));
};

export const pickLoginLocationId = (
  queryId?: string | null,
  persistedId?: string | null,
): string | undefined => {
  const fromQuery = trimQueryValue(queryId);
  if (fromQuery) {
    return fromQuery;
  }
  const fromPersist = trimQueryValue(persistedId);
  return fromPersist || undefined;
};

export const sanitizePostLoginRedirect = (
  redirect?: string | null,
): typeof PAYMENT_DASHBOARD_PATH | undefined => {
  const path = trimQueryValue(redirect).split('?')[0];
  if (path === PAYMENT_DASHBOARD_PATH) {
    return PAYMENT_DASHBOARD_PATH;
  }
  return undefined;
};

export const redirectForUnauthenticatedPath = (
  pathname: string,
): typeof PAYMENT_DASHBOARD_PATH | undefined =>
  pathname === PAYMENT_DASHBOARD_PATH ? PAYMENT_DASHBOARD_PATH : undefined;

export type PostLoginDestination =
  | { to: '/payment/payment-dashboard'; search: { id: string } }
  | { to: '/dashboard'; search: { id: string } };

export const buildPostLoginDestination = (
  locationId: string,
  redirect?: string | null,
): PostLoginDestination => {
  if (sanitizePostLoginRedirect(redirect) === PAYMENT_DASHBOARD_PATH) {
    return {
      to: '/payment/payment-dashboard',
      search: { id: locationId },
    };
  }

  return {
    to: '/dashboard',
    search: { id: locationId },
  };
};
